/**
 * Build a WebSocket URL for the given API endpoint.
 *
 * The WebSocket endpoints are proxied under the app's API/asset mount
 * (PUBLIC_URL, e.g. '/stats') — the SPA is served at root, but the API stays
 * under /stats. Also handles protocol detection and the localhost dev override.
 *
 * @param {string} endpoint - API path (e.g. "/api/live/ws" or "/api/queue/ws/123")
 * @returns {string} Full WebSocket URL
 */
export function buildWebSocketUrl(endpoint) {
  const host = window.location.host;

  // Local development override
  if (host.includes('localhost:3000')) {
    return `ws://localhost:8001${endpoint}`;
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const prefix = process.env.PUBLIC_URL || '';
  return `${protocol}//${host}${prefix}${endpoint}`;
}
